import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
//* DayJS
import dayjs from 'dayjs'
//* Material UI
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const styles = (theme) => ({
  ...theme.spreadThis,

  // commentData: {
  //   marginLeft: 40,
  // },
})

const Comments = ({ comments, classes }) => {
  return (
    <StyledCommentContainer container>
      {comments.map((comment, index) => {
        const { body, createdAt, userImage, userHandle } = comment
        return (
          <Fragment key={createdAt}>
            <StyledComment item sm={12}>
              <StyledCommentGrid container>
                <CommentImage item sm={3}>
                  <img src={userImage} alt='comment' />
                </CommentImage>
                <CommentsContent item sm={9}>
                  <div className={classes.commentData}>
                    <Typography
                      variant='h5'
                      component={Link}
                      to={`/users/${userHandle}`}
                      color='primary'
                    >
                      {userHandle}
                    </Typography>
                    <Typography variant='body2' color='textSecondary'>
                      {dayjs(createdAt).format('h:mm a, MMMM DD YYYY')}
                    </Typography>
                    <hr className={classes.invisibleSeparator} />
                    <Typography variabnt='body1'>{body}</Typography>
                  </div>
                </CommentsContent>
              </StyledCommentGrid>
            </StyledComment>
            {index !== comments.length - 1 && (
              <hr className={classes.visibleSeparator} />
            )}
          </Fragment>
        )
      })}
    </StyledCommentContainer>
  )
}

const StyledCommentContainer = styled(Grid)`
  border: 1px solid rgba(0, 0, 0, 0.4);
`
const StyledComment = styled(Grid)`
  min-height: 20vh;
  width: 100%;
  display: flex;
  align-items: center;
`
const StyledCommentGrid = styled(Grid)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
`
const CommentImage = styled(Grid)`
  margin: 2rem;
  margin-left: 2.5rem;
  @media (max-width: 600px) {
    margin: 0rem 1rem;
  }
  img {
    /* max-width: 100%; */
    height: 150px;
    width: 150px;
    object-fit: cover;
    border-radius: 50%;
    margin-left: 0px;
    @media (max-width: 600px) {
      /* max-width: 100%; */
      height: 100px;
      width: 100px;
      object-fit: cover;
      border-radius: 50%;
      margin-left: 0px;
    }
  }
`
const CommentsContent = styled(Grid)``

Comments.propTypes = {
  comments: PropTypes.array.isRequired,
}

export default withStyles(styles)(Comments)
